import * as React from "react"

const BlockTitle = ({
  level,
  title,
  subtitle,
  titleSize,
  subtitleSize,
  backgroundColour,
  className,
}) => {
  const TitleTag = `h${level}`

  const titleColour = {
    dark: "text-white",
    white: "text-navy-800",
  }

  const subtitleColour = {
    dark: "text-blue",
    white: "text-gray-500",
  }

  const titleStyle = `flex flex-col ${titleSize ? titleSize : "text-3xl"} ${
    backgroundColour ? titleColour[backgroundColour] : titleColour["white"]
  }`
  const subtitleStyle = `font-sans font-light text-lg uppercase tracking-[0.4em] leading-none ${
    backgroundColour
      ? subtitleColour[backgroundColour]
      : subtitleColour["white"]
  }`

  return (
    <div className={`mb-4 ${className ? className : ""}`}>
      <div className={"h-0.5 bg-blue w-32 mb-6"} />
      <TitleTag className={titleStyle}>
        {subtitle && <span className={subtitleStyle}>{subtitle}</span>}
        {title}
      </TitleTag>
    </div>
  )
}

export default BlockTitle
